export const COMMISSION_STATE = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REFUNDED: 'REFUNDED',
  ON_REFUND: 'ON_REFUND',
  TASK_DONE: 'TASK_DONE',
  END: 'END',
} as const;
